import { render, staticRenderFns } from "./PageSuspend.vue?vue&type=template&id=69f3751f&"
import script from "./PageSuspend.vue?vue&type=script&lang=js&"
export * from "./PageSuspend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports